<template>
  <div style="user-select: none;" class="flex option-container items-center">
    <div class="col-12 flex flex-wrap">
      <div class="col-2">
        <div :class="['flex mr2 full-height pointer', { 'disabled': isDisabled }]" @click="toggleOption()">
          <span :id="`option-radio-${radioId}`" :class="['custom-radio flex', { 'selected-item': isActive }]"></span>
        </div>
      </div>
      <div :class="['col-10', { 'disabled': isDisabled || !isActive}]">
        <span class="bold h3 product_name">{{ localOption.name.toLowerCase() }}</span>
      </div>
      <span v-if="localOption.tdaDescription" class="flex col-12 h6 bold ml4">
        {{ localOption.tdaDescription }}
      </span>
    </div>
    <div class="col-12 flex flex-wrap">
      <div class="col-6 flex items-center justify-center">
        <i v-if="showQuantityChanger && !isDisabled && !isOptionQuantitySelectedDisabled" style="top: 2px" :class="[{'icon icon-minus pointer': true},{'disabled':canShow(-1)}]" @click="handleQuantityChange(-1)"></i>
        <span class="mx2 bold">{{ localOption.quantity }}</span>
        <i v-if="showQuantityChanger && !isDisabled && !isOptionQuantitySelectedDisabled && showAddMoreQuantityChanger" style="top: 2px" :class="[{'icon icon-add-more-icon pointer':true},{'disabled':canShow(1)}]" @click="handleQuantityChange(1)"></i>
      </div>
      <div class="col-6 flex items-center justify-end">
        <h4 v-if=" getPrice > 0" class="h3 cond lower">{{ getPrice.toFixed(2) }} €<span v-if="isOptionInsuranceDaily && isOfferStage" class="h4"> / jour</span><span v-if="isOptionRecurring" class="h4"> / mois</span></h4>
        <h4 v-else class="h3 cond lower">Offert</h4>
      </div>
    </div>
  </div>
</template>

<script>
import { optionTypes } from '@/utils/utils';

export default {
  props: {
    option: Object,
    isActive: Boolean,
    radioId: String
  },
  data () {
    return {
      optionTypes: optionTypes,
      availableOptions: this.$store.state.availableOptions,
      localOption: {
        ...this.$props.option,
        quantity: this.$props.option.quantity || 1
      }
    };
  },
  computed: {
    isInternalSession () {
      return this.$store.state.siteInfo && this.$store.state.siteInfo.is_internal_session;
    },
    isOptionInsuranceDaily () {
      return this.localOption.detail.insurance && this.localOption.detail.insuranceDetail.insuranceType === 'DAILY';
    },
    isOfferStage () {
      const offer = this.$store.state.offerInfo;
      return offer && offer.detail ? offer.detail.stage || offer.detail.stage1D : false;
    },
    showQuantityChanger () {
      return !this.option.fixedQuantity;
    },
    showAddMoreQuantityChanger () {
      return this.option.hasMaxQuantity ? this.localOption.quantity < this.option.maxQuantity : true;
    },
    getPrice () {
      if (this.$store.state.currentParticipant) {
        const price = this.localOption.detail.prices.find(p => {
          if (this.isInternalSession) {
            return p.period.uuid === this.$store.state.currentParticipant.tariff.period.uuid && p.priceCategory.uuid === this.$store.state.currentParticipant.tariff.priceCategory.uuid;
          }
          return p.tariffCategoryCode === this.$store.state.currentParticipant.tariff.tariffCategoryCode;
        });

        if (this.localOption.promo) {
          const promo = price.promotions.find(prom => prom.id === this.localOption.promo.id);

          if (promo) {
            return this.localOption.quantity * promo.price;
          }
        }
        return this.localOption.quantity * parseFloat(price.price / 100);
      }
      return null;
    },
    isDisabled () {
      return this.localOption.optionType === this.optionTypes.MANDATORY;
    },
    isOptionQuantitySelectedDisabled () {
      return this.localOption.detail.recurring;
    },
    isOptionRecurring () {
      return this.$store.state.offerInfo.detail.recurring && !this.option.registrationFees;
    }
  },
  methods: {
    canAdd (quantityToUpdate) {
      if (this.localOption.fixedQuantity) {
        const optionInAvailableOptions = this.availableOptions.find(option => {
          if (this.isInternalSession) {
            return option.uuid === this.localOption.uuid;
          }
          return option.horanet_product.horanet_product_code === this.localOption.horanet_product.horanet_product_code;
        });
        if (optionInAvailableOptions && optionInAvailableOptions.quantity < quantityToUpdate) {
          return false;
        }
      } else if (this.localOption.optionType === this.optionTypes.MANDATORY && quantityToUpdate === 0) {
        return false;
      }
      return true;
    },
    canShow (quantity) {
      const quantityToUpdate = parseInt(this.localOption.quantity) + (quantity);
      const canAdd = this.canAdd(quantityToUpdate);

      if (quantityToUpdate === 0) {
        return true;
      }
      return !canAdd;
    },
    handleQuantityChange (quantity) {
      const quantityToUpdate = parseInt(this.localOption.quantity) + (quantity);
      const canAdd = this.canAdd(quantityToUpdate);

      if (!canAdd) {
        return;
      }

      this.localOption.quantity = quantityToUpdate > 0 ? quantityToUpdate : 0;
      this.$emit('manageOption', { ...this.localOption });
    },
    toggleOption () {
      if (this.localOption.optionType === this.optionTypes.OPTIONAL) {
        this.$emit('manageOption', { ...this.localOption });
      }
    }
  }
};
</script>

<style scoped>
  @media (max-width: 40em) {
    .product_name{
      font-size: 1.15rem;
    }

    .option-container{
      flex-wrap: wrap;
    }
  }

</style>
